import { TrackReference } from '@livekit/components-core'
import { useVisualStableUpdate } from '@livekit/components-react'
import { Room } from 'livekit-client'
import Tile from './Tile'
import useMuseTracks from './useMuseTracks'

type Props = {
    room: Room
    hostUserId: string
}

const HostLayout = ({ room, hostUserId }: Props) => {
    const museTracks = useMuseTracks(room, hostUserId)

    const mainTrack = museTracks.host ?? museTracks.all[0]
    const others = museTracks.all.filter((t) => t !== mainTrack)
    const remainingTracks = useVisualStableUpdate(others, 3)

    if (!mainTrack) {
        return <>no main track</>
    }

    const carouselTiles = remainingTracks.map((t) => {
        return (
            <Tile
                key={t.publication?.trackSid ?? t.participant.sid}
                trackRef={t}
                className="rounded-lg border-2 border-white"
            />
        )
    })

    return (
        <div>
            <div className="absolute top-2 left-2 z-10 w-[15vw] flex flex-col gap-2">{carouselTiles}</div>
            <div className="absolute top-2 right-2 z-10 opacity-30 w-[9vw] hidden">
                <img src="/muse-logo-white.png" />
            </div>
            <Tile trackRef={mainTrack as TrackReference} className="w-screen h-screen" id="host-video-tile" />
        </div>
    )
}

export default HostLayout
